import { login, getInfo, logout } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
// import { Notification } from 'element-ui'

const user = {
  state: {
    token: getToken(),
    user: {},
    organizationId: '',
    project: {},
    orgs: [],
    permissions: [],
    permissionsList: [],
    roles: [],
    // 第一次加载菜单时用到
    loadMenus: false,
    content: 0
  },

  mutations: {
    SET_ORGS: (state, orgs) => {
      state.orgs = orgs
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions.reduce((obj, item) => {
        obj[item.authority] = true
        return obj
      }, {})
    },
    SET_PERMISSIONS_LIST: (state, permissions) => {
      state.permissionsList = permissions
    },
    SET_ORGANIZATIONID: (state, [organizationId, detail]) => {
      localStorage.setItem(`${state.user.username}/orgId`, organizationId)
      localStorage.setItem(`${state.user.username}/project`, JSON.stringify(detail))
      state.organizationId = organizationId
      state.project = detail
      console.log('SET_ORGANIZATIONID detail: ', detail)
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_LOAD_MENUS: (state, loadMenus) => {
      state.loadMenus = loadMenus
    },
    SET_MESSAGE_CONTENT: (state, content) => {
      state.content = content
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        login(userInfo.username, userInfo.password, userInfo.code, userInfo.uuid).then(res => {
          setToken(res.token, rememberMe)
          commit('SET_TOKEN', res.token)
          // if (!res.user.orgs || res.user.orgs.length === 0) {
          //   Notification.error({
          //     title: '当前用户没有登陆权限',
          //     duration: 5000
          //   })
          //   reject('当前用户没有登陆权限！')
          // } else {
          //   setUserInfo(res.user, commit)
          //   // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
          //   commit('SET_LOAD_MENUS', true)
          //   resolve()
          // }
          console.log('Login  res.user: ', res.user)
          setUserInfo(res.user, commit)
          // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
          commit('SET_LOAD_MENUS', true)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(async res => {
          await setUserInfo(res, commit)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(res => {
          logOut(commit)
          resolve()
        }).catch(error => {
          logOut(commit)
          reject(error)
        })
      })
    },

    updateLoadMenus({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_MENUS', false)
      })
    },
    setOrganizationId({ commit }, [organizationId, detail]) {
      commit('SET_ORGANIZATIONID', [organizationId, detail])
    },
    setMessageContent({ commit }, content) {
      commit('SET_MESSAGE_CONTENT', content)
    }
  }
}

export const logOut = (commit) => {
  commit('SET_TOKEN', '')
  commit('SET_ROLES', [])
  removeToken()
}

export const setUserInfo = (res, commit) => {
  console.log('setUserInfo  res: ', res)
  return new Promise((resolve, reject) => {
    // const hasLocalOrgInfo = false
    let orgId = localStorage.getItem(`${res.user.username}/orgId`)
    let project = JSON.parse(localStorage.getItem(`${res.user.username}/project`) || '{}')
    console.log('localStorage   project: ', JSON.parse(JSON.stringify(project)))
    /*
    * 这里会过滤掉两种情况
    * 1、如果是第一次登陆，这里是获取不到任何数据的，
    * 2、如果用户之前选择的机构已经被删除了
    * */
    // for (const val of res.orgs) {
    // if (val.id === orgId) {
    //   hasLocalOrgInfo = true
    //   break
    // }
    // }
    // 查找localStorage中的id，是否存在树中
    // if (JSON.stringify(res.orgs).indexOf(orgId) !== -1) {
    //   hasLocalOrgInfo = true
    // }
    // console.log('project && project.code: ', project && project.code)
    // if (project && project.code) {
    //   hasLocalOrgInfo = true
    // }
    // console.log('hasLocalOrgInfo: ', hasLocalOrgInfo)
    // console.log('res.orgs: ', res.orgs)
    if (JSON.stringify(res.user?.orgs).indexOf(orgId) === -1 || !project || !project.code) {
      orgId = res.user?.orgs[0]?.id
      project = res.user?.orgs[0]
    }
    // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
    if (res.permissions.length === 0) {
      commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT'])
    } else {
      commit('SET_ROLES', res.permissions)
    }
    commit('SET_USER', res.user)
    commit('SET_ORGS', res.orgs)
    commit('SET_PERMISSIONS_LIST', res.permissions)
    console.log('!!!!!!!!!!!project: ', project)
    commit('SET_ORGANIZATIONID', [orgId || '', project])
    resolve()
  })
}

export default user
